import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../Context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user, isAuthLoading } = useContext(AuthContext);

    if (isAuthLoading) {
        return <div>Cargando...</div>; // Espera a que termine de cargar
    }

    return user ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
